import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpApi) // load translation using http -> see /public/locales
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      /* translation file path */
      loadPath: "/assets/i18n/translations/{{lng}}.json"
    },
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    detection: {
      order: ["localStorage", "navigator"], // First look in localStorage, then navigator
      caches: ["localStorage"] // Save the language in local storage
    }
  });

export default i18n;
